<template>
    <div class="Hamburger">
        <div class="Hamburger__burger-wrapper" 
            :class="[{ 'is-active': $parent.is_open }, { 'is-demo': is_demo }]">
            <span class="Hamburger__burger"/>
        </div>
    </div>
</template>

<script>

import gsap from "gsap"

export default {   
    name: 'Hamburger',
    computed: {
        is_demo() { return this.$store.getters['commons/is_demo'] },
        open_training() { return this.$store.getters['commons/open_training'] }
    },

    watch: {
        is_demo(nw) {
            const delay = nw ? 3.25 : 1.25
            this.addMotion(delay)   
        },
        open_training(nw) {
            if(nw != null)   
                this.addMotion(1.25)
        },
    },

    mounted() {
        this.$used = false
    },

    methods: {

        addMotion(delay) {  

            if(this.$used)
                return

            if(this.$twn)
                this.$twn.kill()

            this.$used = true

            this.$twn = gsap.from(this.$el, { 
                y: -100, 
                duration: .5, 
                ease: 'cubic.out', 
                delay: delay, onComplete: ()=>{
                    this.$used = false
                } 
            })

        },

    }

}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'
@import '~@/components/assets/styl/Hamburger-icon'

.Hamburger
    width 100%
    position fixed

    &__burger
        hamburger-generator(25px, 2px, 5px, grey, $timing-function: linear)

    &__burger-wrapper
        position relative
        cursor pointer 

        z-index 999
        padding 0px
        z-index 99999999999

        &.is-active
            .Hamburger__burger
                hamburger-animation()  

        &.is-demo
            .Hamburger__burger:before
            .Hamburger__burger:after
                background white

</style>


